import React from 'react'
import "./Spinner.css"

const Spinner = () => {
  return (
    <div>
      <div className="custom-loader"></div>
    </div>
  )
}

export default Spinner
